import { iDefaultProps } from './views/partner/tenants/create-tenant.types';

export * from './data/route-paths';

export const ROLE_TYPE = {
  ADMIN: { id: 'admin', name: 'Partner' },
  SHIPPING_CLIENT: { id: 'shipping_client', name: 'Client' },
};

export const DROPDOWN_TYPES = {
  APPLIED_DROPDOWN: 'appliedDropdown',
  DROPDOWN: 'dropdownwithtitle',
  ASYNC_DROPDOWN: 'asyncdropdownwithtitle',
  MULTI_DROPDOWN: 'dropdownwithtitle',
  MULTI_ASYNC_DROPDOWN: 'asyncmultidropdownwithtitle',
  DATE_DROPDOWN: 'dateDropdown',
  TIME_DROPDOWN: 'timeDropdown',
  CREATED_AT_DROPDOWN: 'createdAtDropdown'
};

export const SAMPLE_FILES = {
  UPLOAD_INVENTORY_NON_SERIALISED: 'https://omniful-staging-uploads.s3.eu-central-1.amazonaws.com/wms/hub_inventory/Location+Inventory+Upload+-+Sheet1.csv',
  UPLOAD_INVENTORY_SERIALISED: 'https://omniful-staging-uploads.s3.eu-central-1.amazonaws.com/wms/hub_inventory/serialised+barcode+sample+sheet.csv',
  NON_BATCHED_TO_BATCHED: 'https://omniful-staging-uploads.s3.eu-central-1.amazonaws.com/wms/inventory/sku_config/Non+batch+-_+Batch+-+Sheet1.csv',
  BULK_UPLOAD_TAX_INVOICES: 'https://omniful-production-uploads.s3.eu-central-1.amazonaws.com/billing/omniful_bill/upload/tax+invoices+-+Sheet1.csv',
}

export const DEFAULT_DASHBOARD_LANGUAGE = {
  label: 'English',
  value: 'en-US',
  direction: 'ltr',
  country_code: 'us',
}

export const COMMERCIAL_ROLE = {
  MERCHANT: { label: 'Merchant', value: 'merchant' },
  FULFILLMENT_3PL: { label: 'Fulfillment 3PL', value: 'fulfillment_3pl' }
}

/** Who receives invoice payment proceeds for this tenant (API: billing_info.partner). */
export const TENANT_BILLING_PARTNER = {
  SELF: { label: 'Self', value: 'self' },
  EXTERNAL: { label: 'External', value: 'external' },
  MARKETPLACE: { label: 'Marketplace', value: 'marketplace' },
}

export const TENANT_BILLING_STATUS = {
  PAID: { value: 'paid', label: 'Paid' },
  PENDING: { value: 'pending', label: 'Pending' },
  DUE_SOON: { value: 'due_soon', label: 'Due Soon' },
  DUE_TODAY: { value: 'due_today', label: 'Due Today' },
  OVERDUE: { value: 'overdue', label: 'Overdue' },
} as const

export const TENANT_BILLING_STATUS_MAP: Record<string, { name: string; badgeClassNames: string }> = {
  paid: { name: 'Paid', badgeClassNames: 'bg-success_light text-success' },
  pending: { name: 'Pending', badgeClassNames: 'bg-dark_1 text-dark' },
  due_soon: { name: 'Due Soon', badgeClassNames: 'bg-warning_light text-warning' },
  due_today: { name: 'Due Today', badgeClassNames: 'bg-warning_light text-warning' },
  overdue: { name: 'Overdue', badgeClassNames: 'bg-danger_light text-danger' },
}

export const createTenantDefaultState: iDefaultProps = {
  name: '',
  phone: { countryCode: null, contactNumber: '' },
  email: '',
  implementation_users: [{ name: '', email: '', phone: { countryCode: null, contactNumber: '' } }],
  type: null,
  commercial_role: COMMERCIAL_ROLE.FULFILLMENT_3PL,
  dashboard_language: DEFAULT_DASHBOARD_LANGUAGE,
  user_guidance_enabled: false,
  workspace: '',
  address_line: '',
  country: null,
  state: null,
  city: null,
  postal_code: '',
  environment: null,
  custom_theme_enabled: false,
  primary: '#7C3AED',
  primary_light: '#DDD6FE',
  primary_lighter: '#F5F3FF',
  primary_dark: '#6D28D9',
  is_login_white_labelled: false,
  login_background: '#F4F5F7',
  login_image_url: null,
  pricing_plan_ids: null,
  add_on_feature_ids: null,
  billing_info: { partner: TENANT_BILLING_PARTNER.SELF },
  is_active: true
}

export const THEME_COLOR_KEYS = {
  PRIMARY: 'primary',
  PRIMARY_LIGHT: 'primary-light',
  PRIMARY_LIGHTER: 'primary-lighter',
  PRIMARY_DARK: 'primary-dark',
}

export const CREATE_TENANT_INPUT_FIELDS = {
  NAME: 'name',
  PHONE: 'phone',
  EMAIL: 'email',
  IMPLEMENTATION_USERS: 'implementation_users',
  TYPE: 'type',
  COMMERCIAL_ROLE: 'commercial_role',
  DASHBOARD_LANGUAGE: 'dashboard_language',
  USER_GUIDANCE_ENABLED: 'user_guidance_enabled',
  WORKSPACE: 'workspace',
  ADDRESS_LINE: 'address_line',
  COUNTRY: 'country',
  STATE: 'state',
  CITY: 'city',
  POSTAL_CODE: 'postal_code',
  ENVIRONMENT: 'environment',
  CUSTOM_THEME_ENABLED: 'custom_theme_enabled',
  PRIMARY: 'primary',
  PRIMARY_LIGHT: 'primary_light',
  PRIMARY_LIGHTER: 'primary_lighter',
  PRIMARY_DARK: 'primary_dark',
  IS_LOGIN_WHITE_LABELLED: 'is_login_white_labelled',
  LOGIN_BACKGROUND: 'login_background',
  LOGIN_IMAGE_URL: 'login_image_url',
  PRICING_PLAN_IDS: 'pricing_plan_ids',
  ADD_ON_FEATURE_IDS: 'add_on_feature_ids',
  BILLING_INFO_PARTNER: 'billing_info.partner',
  IS_ACTIVE: 'is_active'
}

export const THEME_COLORS = {
  PRIMARY: '#7C3AED',
  PRIMARY_LIGHT: '#DDD6FE',
  PRIMARY_LIGHTER: '#F5F3FF',
  PRIMARY_DARK: '#6D28D9',
  LOGIN_BACKGROUND: '#F4F5F7'
}

export const SWITCH_KEYS = {
  ENABLE: 'Enable',
  DISABLE: 'Disable'
}

export const INVENTORY_TYPE = {
  SERIALISED: { value: 'serialised', label: 'Serialised' },
  NON_SERIALISED: { value: 'non-serialised', label: 'Non-Serialised' }
}

export const QC_STATUS = {
  PASSED: { value: 'pass', label: 'Pass' },
  FAILED: { value: 'fail', label: 'Fail' }
}

export const SELLER_ONBOARDING_FILTERS = {
  TYPE_OF_INVENTORY: 'type_of_inventory',
  QC_STATUS: 'qc_status'
}

export const TENANT_FILTERS = {
  IS_ACTIVE: 'is_active',
  ENVIRONMENT: 'environment',
  COMMERCIAL_ROLE: 'commercial_role',
  BILLING_STATUS: 'billing_status',
  SUSPENSION_DATE: 'suspension_date_range',
}

export const RESTRICTED_EMAILS = ['support@omniful.ai', 'support@omniful.com', 'supportusers@omniful.ai', 'supportusers@omniful.com'];

export const VALID_DOMAINS = ['@omniful.com', '@omniful.ai'];

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const TENANT_TYPE = {
  SELF_USAGE: { label: 'Self', value: 'Self' },
  FULFILLMENT_CENTRE: { label: 'Fulfilment Center', value: 'Fulfilment Centre' }
}

export const CREATE_PRICING_PLAN_INPUT_FIELDS = {
  NAME: 'name',
  SERVICES: 'services'
}

export const SALES_CHANNEL_TAGS = {
  SALLA: 'salla',
  SALLA_V2: 'salla_v2'
}

export const STATUS = {
  ACTIVE: { label: 'Active', value: 'active' },
  INACTIVE: { label: 'Inactive', value: 'inactive' }
}

export const ENVIRONMENT = {
  TESTING: { label: 'Testing', value: 'testing' },
  LIVE: { label: 'Live', value: 'live' }
}

export const ALL_OPTION = { label: 'All', value: null }

export const MAX_IMPLEMENTATION_USERS = 10;

export const INTEGRATION_TYPE = [
  { label: 'Shipping Only', value: 'shipping_only' },
  { label: 'Fulfillment + Shipping', value: 'fulfillment_shipping' }
]

export const INPUT_TYPES = {
  TEXT: 'text',
  PASSWORD: 'password',
  SEARCH: 'search',
  NUMBER: 'number',
  FILE: 'file',
  DATE: 'date',
  TIME: 'time',
  API: 'api',
  DROPDOWN: 'dropdown',
  EMAIL: 'email',
  PHONE: 'phone',
  RADIO: 'radio',
}

export const TEXT_AREA = 'textarea'

export const TOOLTIP_PLACEMENT = {
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
  TOP_START: 'top-start',
  TOP_END: 'top-end',
  BOTTOM_START: 'bottom-start',
  BOTTOM_END: 'bottom-end',
  LEFT_START: 'left-start',
  LEFT_END: 'left-end',
  RIGHT_START: 'right-start',
  RIGHT_END: 'right-end',
}

export const DEFAULT_COUNTRY = {
  label: 'Saudi Arabia',
  value: 'SA',
  calling_code: '+966',
  country_code: 'SA',
}

export const REGEX_PATTERNS = {
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
  NUMBER: /^\d*\.?\d*$/, // Allow only numbers and decimal points
  HTML_TAGS: /<([a-zA-Z][a-zA-Z0-9-]*)(\s+[^<>]*?)?>/i, // Allow only valid HTML tags
  ONLY_ZEROES: /^0+$/, // Allow only zeroes
  ONLY_ZEROES_WITH_DECIMAL: /^0+\.$/, // Allow only zeroes with a dot
  ONLY_ZEROES_WITH_DECIMAL_AND_NUMBER: /^0+\.\d/, // Allow only zeroes with a dot and a number
  ONLY_ZEROES_WITH_LEADING_ZEROES: /^0+/, // Allow only leading zeroes
  ONLY_ZEROES_WITH_LEADING_ZEROES_AND_NUMBER: /[0-9]+-+/g, // Allow only leading zeroes and a number after minus sign
  THREE_DECIMAL_PLACES: /^-?\d+(\.\d{1,3})?$/,
  FOUR_DECIMAL_PLACES: /^-?\d+(\.\d{1,4})?$/,
  TWO_DECIMAL_PLACES: /^\d+(\.\d{0,2})?$/,
  URL_VALIDATION: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i,
}

export const LOCAL_STORAGE_KEYS = {
  AUTH: 'auth',
  USER_NAME: 'userName',
  DEVELOPER_CUSTOM_HEADERS: 'x-omniful-custom-headers',
  DEVELOPER_CUSTOM_BASE_URL: 'x-omniful-custom-base-url',
  DEVELOPER_ENV_OVERRIDES: 'x-omniful-env-overrides',
  BANNER_KEY: 'banner',
}

export const BUTTON_TYPE = {
  REGULAR: 'regular',
  COMPACT: 'compact',
  COMPRESSED: 'compressed'
} as const;

export const BUTTON_STYLE = {
  FILLED: 'filled',
  OUTLINED: 'outlined',
  NO_BACKGROUND: 'noBackground',
  TEXT_ONLY: 'textOnly'
} as const;

export const NETWORK_STATUS = {
  ONLINE: 'online',
  OFFLINE: 'offline'
}

export const SESSION_STORAGE_KEYS = {
  MOBILE_WARNING_SHOWN: 'mobileWarningShown',
  RETRY_LAZY_REFRESHED: 'retry-lazy-refreshed',
  COLLAPSED_CONTAINER_LIST: 'adminCollapsedContainerList',
}

export const FILE_TYPES = {
  TXT: {
    type: 'text/plain',
    extensions: ['.txt', '.text']
  },
  JPG: {
    type: 'image/jpeg',
    extensions: ['.jpg']
  },
  JPEG: {
    type: 'image/jpeg',
    extensions: ['.jpeg']
  },
  PNG: {
    type: 'image/png',
    extensions: ['.png']
  },
  SVG: {
    type: 'image/svg+xml',
    extensions: ['.svg']
  },
  GIF: {
    type: 'image/gif',
    extensions: ['.gif']
  },
  CSV: {
    type: 'text/csv',
    extensions: ['.csv']
  },
  PDF: {
    type: 'application/pdf',
    extensions: ['.pdf']
  },
  XLS: {
    type: 'application/vnd.ms-excel',
    extensions: ['.xls']
  },
  XLSX: {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    extensions: ['.xlsx']
  },
  DOC: {
    type: 'application/msword',
    extensions: ['.doc']
  },
  DOCX: {
    type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    extensions: ['.docx']
  },
  ODS: {
    type: 'application/vnd.oasis.opendocument.spreadsheet',
    extensions: ['.ods']
  },
  IMG: {
    type: 'image/*',
    extensions: ['.apng', '.avif', '.bmp', '.gif', '.ico', '.jpeg', '.jpg', '.png', '.svg', '.tif', '.tiff', '.webp']
  },
  MP4: {
    type: 'video/mp4',
    extensions: ['.mp4']
  },
  MOV: {
    type: 'video/quicktime',
    extensions: ['.mov']
  }
}

export const MAX_FILE_SIZE_ALLOWED_IN_BYTES = 10485760

export const ONE_MB_IN_BYTES = 1048576

export const WORKSPACE_ENVIRONMENT = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  PRODUCTION: 'production'
}

export const BANNER_KEYS = {
  DEVELOPER_CORS_BANNER: 'developer-cors-banner'
};

export const BANNER_VARIANTS = {
  DANGER: 'DANGER',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  INFO: 'INFO',
  NEUTRAL: 'NEUTRAL',
} as const;

export const BANNER_TYPES = {
  BANNER: 'BANNER',
  NOTIFICATION: 'NOTIFICATION',
} as const;
